import {
  Box,
  Flex,
  HStack,
  IconButton,
  Image,
  Select,
  Spacer,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import { useTrialDrivesQuery } from "./index.generated";
import { useState } from "react";
import cafe from "../../../../assets/icon_cafe.svg";
import restroom from "../../../../assets/icon_toilet.svg";
import parkingFree from "../../../../assets/icon_parking_free.svg";
import parlingPaid from "../../../../assets/icon_parking_paid.svg";
import restaurant from "../../../../assets/icon_restaurant.svg";
import view_icon from "./assets/230831_subaru_road_icon_view.svg";
import view_off_icon from "./assets/230831_subaru_road_icon_view_off.svg";
import expand_icon from "./assets/230831_subaru_road_icon_expand.svg";
import expand_off_icon from "./assets/230831_subaru_road_icon_reduce.svg";

import {
  TrialDriveFragment,
  TrialDriveSpotFragment,
} from "../../index.generated";
import { Coordinate } from "~/generated/graphql.types";
import Draggable from "react-draggable";
import { CloseIcon } from "@chakra-ui/icons";
import { AiOutlineCompress, AiOutlineExpand } from "react-icons/ai";

export const TrialDriveMenu = ({
  userGroupId,
  showTrialDrive,
  isTrialDriveSelected,
  trialDrive,
  maxLength,
  onChangeTrialDriveId,
  switchShowTrialDrive,
  focusOnSpot,
  onClickPhoto,
}: {
  userGroupId: string;
  showTrialDrive: boolean;
  isTrialDriveSelected: boolean;
  trialDrive: TrialDriveFragment | undefined;
  maxLength: string;
  onChangeTrialDriveId: (trialDriveId: string) => void;
  switchShowTrialDrive: () => void;
  focusOnSpot: (coordinate: Coordinate) => void;
  onClickPhoto: (photoUrl: string) => void;
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const [trialDrives] = useTrialDrivesQuery({
    variables: { userGroupId: userGroupId },
  });

  const visibleIcon = showTrialDrive ? view_icon : view_off_icon;
  const visibleIconToolTipMessage = showTrialDrive
    ? "地図上の走行メモを非表示にする"
    : "地図上に走行メモを表示する";
  const expandIcon = isExpanded ? expand_icon : expand_off_icon;
  const expandIconToolTipMessage = isExpanded
    ? "走行メモの詳細を非表示にする"
    : "走行メモの詳細を表示する";

  const contents = isExpanded ? (
    isTrialDriveSelected ? (
      <TrialDriveSpotList
        trialDriveName={trialDrive?.name ?? ""}
        trialDriveSpots={trialDrive?.spots ?? []}
        focunOnSpot={focusOnSpot}
        onClickPhoto={onClickPhoto}
      />
    ) : (
      <>
        <Text fontSize={"sm"}>閲覧したい記録を選択してください。</Text>
        <Text fontSize={"sm"}>
          メモをクリックするとメモを残した場所にカメラが移動します。
        </Text>
      </>
    )
  ) : null;
  return (
    <Box
      w={300}
      bg="#0F2446"
      opacity={0.8}
      color={"white"}
      rounded={10}
      p={5}
      h={isExpanded && isTrialDriveSelected ? maxLength : "auto"}
      overflowY="scroll"
    >
      <HStack>
        <Tooltip hasArrow label={visibleIconToolTipMessage}>
          <Image boxSize={5} src={visibleIcon} onClick={switchShowTrialDrive} />
        </Tooltip>
        <Select
          onChange={(e) => {
            onChangeTrialDriveId(e.target.value);
          }}
        >
          <>
            <option value={""} style={{ color: "black" }}>
              記録を選択してください
            </option>
            {trialDrives.data?.trialDrives.map((trialDrive) => (
              <option
                value={trialDrive.trialDriveId}
                key={trialDrive.trialDriveId}
                style={{ color: "black" }}
              >
                {trialDrive.name}
              </option>
            ))}
          </>
        </Select>
        <Tooltip hasArrow label={expandIconToolTipMessage}>
          <Image
            boxSize={5}
            src={expandIcon}
            onClick={() => {
              setIsExpanded(!isExpanded);
            }}
          />
        </Tooltip>
      </HStack>
      <Box>{contents}</Box>
    </Box>
  );
};

const TrialDriveSpotList = ({
  trialDriveName,
  trialDriveSpots,
  focunOnSpot,
  onClickPhoto,
}: {
  trialDriveName: string;
  trialDriveSpots: TrialDriveSpotFragment[];
  focunOnSpot: (coordinate: Coordinate) => void;
  onClickPhoto: (photoUrl: string) => void;
}) => {
  return (
    <>
      <Text fontSize="large">{trialDriveName} </Text>

      <VStack>
        {trialDriveSpots.map((spot) => (
          <TrialDriveSpotListItem
            key={spot.trialDriveSpotId}
            spot={spot}
            onClick={() => {
              focunOnSpot({
                lat: spot.latitude,
                lon: spot.longitude,
              });
            }}
            onClickPhoto={onClickPhoto}
          />
        ))}
      </VStack>
    </>
  );
};

const TrialDriveSpotListItem = ({
  spot,
  onClick,
  onClickPhoto,
}: {
  spot: TrialDriveSpotFragment;
  onClick: () => void;
  onClickPhoto: (photoUrl: string) => void;
}) => {
  return (
    <>
      <Box h={3} />
      <Box w={250} m={10} bg="#071223" rounded={10}>
        <Box onClick={onClick}>
          <Text fontSize="md">{spot.name}</Text>
          <Box h={10}>
            <Flex w="full" ml={2} mt={2} gap={2}>
              {spot.hasCafe ? <Image src={cafe} h={8} /> : null}
              {spot.hasRestaurant ? <Image src={restaurant} h={8} /> : null}
              {spot.hasRestroom ? <Image src={restroom} h={8} /> : null}
              {spot.hasFreeParking ? <Image src={parlingPaid} h={8} /> : null}
              {spot.hasPaidParking ? <Image src={parkingFree} h={8} /> : null}
            </Flex>
          </Box>
          <Text fontSize="sm">{spot.memo}</Text>
        </Box>
        <HStack overflowX="scroll">
          {spot.trialDriveSpotPhotos.map((photo) => (
            <TrialDriveSpotPhoto
              key={photo.trialDriveSpotPhotoId}
              url={photo.url}
              onClick={onClickPhoto}
            />
          ))}
        </HStack>
      </Box>
    </>
  );
};

const TrialDriveSpotPhoto = ({
  url,
  onClick,
}: {
  url: string;
  onClick: (photoUrl: string) => void;
}) => {
  return (
    <>
      <Box flexShrink={0} w={100}>
        <Image
          src={url}
          onClick={() => {
            onClick(url);
          }}
        />
      </Box>
    </>
  );
};

export const DraggableTrialDrivePhotoViewer = ({
  photoUrl,
  onPushCloseButton,
}: {
  photoUrl: string;
  onPushCloseButton: () => void;
}) => {
  const [streetViewSize, setStreetViewSize] = useState<"small" | "large">(
    "large"
  );

  return (
    <Draggable>
      <Flex
        alignItems={"flex-end"}
        direction={"column"}
        bgColor={"#091022"}
        w={360}
        h="fit-content"
      >
        <IconButton
          size="sm"
          bgColor={"#091022"}
          color="white"
          aria-label="expand player"
          variant="ghost"
          icon={<CloseIcon />}
          onClick={onPushCloseButton}
          zIndex={2}
        />
        <Image src={photoUrl} px={5} pt={2} pb={7} />
      </Flex>
    </Draggable>
  );
};
